import React, { useEffect } from 'react'
import getDisplayName from '@hocs/getDisplayName'
import { PageName } from '@app-core/eventTracking/PageName'
import { SearchEvents } from '@libs/customEvents/search'
import {
  trackSearchArticleHashtagSearchEvent,
  trackSearchHotKeywordSearchEvent,
  trackSearchSearchBarSearchEvent,
  trackSearchViewEvent,
} from '@libs/eventTracking/search'
import { PageProperty } from '@app-core/eventTracking/properties'
import { searchUrl } from '@libs/appUrl'

export function withSearchEventTracking(WrappedComponent) {
  function WithSearchEventTracking(props) {
    const { keyword, fromPage, filter, sort } = props
    useTrackSearchView(keyword, fromPage, filter, sort)
    useTrackSearchArticleHashtagSearch(keyword, fromPage)
    useTrackSearchBarSearch(keyword, filter, sort)
    useTrackSearchHotKeywordSearchArticle(filter, sort)
    return <WrappedComponent {...props} />
  }

  WithSearchEventTracking.displayName = `WithSearchEventTracking(${getDisplayName(
    WrappedComponent,
  )})`

  return WithSearchEventTracking
}

export function useTrackSearchView(
  keyword: string,
  fromPage: PageProperty,
  typeFilter: string,
  sortFilter: string,
) {
  useEffect(() => {
    const trackSearchViewInput = {
      keyword,
      fromPage,
      typeFilter,
      sortFilter,
    }
    trackSearchViewEvent(trackSearchViewInput)
  }, [keyword, fromPage, typeFilter, sortFilter])
}

export function useTrackSearchBarSearch(keyword: string, typeFilter: string, sortFilter: string) {
  useEffect(() => {
    const handler = (e) => {
      const toPageUrl = searchUrl(e.detail?.searchKeyword, 1, typeFilter, sortFilter)
      const input = {
        currentKeyword: keyword,
        searchKeyword: e.detail?.searchKeyword,
        toPageUrl,
        typeFilter,
        sortFilter,
      }
      trackSearchSearchBarSearchEvent(input)
    }
    window.addEventListener(SearchEvents.SEARCH_BAR_SEARCH, handler)
    return () => {
      window.removeEventListener(SearchEvents.SEARCH_BAR_SEARCH, handler)
    }
  }, [keyword, typeFilter, sortFilter])
}

export function useTrackSearchHotKeywordSearchArticle(typeFilter: string, sortFilter: string) {
  useEffect(() => {
    const handler = (e) => {
      const toPageUrl = searchUrl(e.detail?.searchKeyword, 1, typeFilter, sortFilter)
      const input = {
        searchKeyword: e.detail?.searchKeyword,
        toPageUrl,
        typeFilter,
        sortFilter,
      }
      trackSearchHotKeywordSearchEvent(input)
    }
    window.addEventListener(SearchEvents.SEARCH_HOT_KEYWORD_SEARCH, handler)
    return () => {
      window.removeEventListener(SearchEvents.SEARCH_HOT_KEYWORD_SEARCH, handler)
    }
  }, [typeFilter, sortFilter])
}

export function useTrackSearchArticleHashtagSearch(keyword: string, fromPage: PageProperty) {
  useEffect(() => {
    const trackSearchViewInput = {
      searchKeyword: keyword,
      fromPage,
    }
    // 判斷從文章頁 hashtag 點過來的
    if (fromPage.pageName !== PageName.ARTICLE) return
    trackSearchArticleHashtagSearchEvent(trackSearchViewInput)
  }, [keyword, fromPage])
}
